export default __webpack_public_path__ + "static/media/car_green_mobile.916aee73.svg";